import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import logo from '../assets/images/logo.jpg';

const HomePage = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />

      {/* Hero */}
      <section
        className="text-white text-center py-5"
        style={{ background: 'linear-gradient(135deg, #212529, #343a40)', flex: 1 }}
      >
        <Container className="py-4">
          <img
            src={logo}
            alt="JLBB Ministries Logo"
            height="120"
            className="mb-4 rounded-circle shadow"
          />
          <h1 className="display-4 fw-bold mb-3">Jesus Le Bon Berger</h1>
          <p className="lead mb-2">221 N Dooley Street, Grapevine, TX 76051</p>
          <p className="text-muted mb-5">
            <i className="bi bi-envelope me-2"></i>info@jesuslebonberger.org
            <span className="mx-3">·</span>
            <i className="bi bi-telephone me-2"></i>(817) 987-3444
          </p>

          <Row className="justify-content-center g-4">
            <Col xs={12} sm={6} md={4}>
              <div className="card h-100 shadow-lg border-0 text-dark">
                <div className="card-body p-4 d-flex flex-column align-items-center">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                    style={{ width: 64, height: 64, background: '#ffc107' }}
                  >
                    <i className="bi bi-calendar-event fs-3 text-dark"></i>
                  </div>
                  <h4 className="fw-bold mb-2">Events</h4>
                  <p className="text-muted mb-4">
                    Conferences, boot camps, and special gatherings for the whole family.
                  </p>
                  <Button
                    as={Link}
                    to="/events"
                    variant="warning"
                    size="lg"
                    className="fw-bold mt-auto w-100"
                  >
                    View Events
                  </Button>
                </div>
              </div>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <div className="card h-100 shadow-lg border-0 text-dark">
                <div className="card-body p-4 d-flex flex-column align-items-center">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                    style={{ width: 64, height: 64, background: '#0d6efd' }}
                  >
                    <i className="bi bi-person-lines-fill fs-3 text-white"></i>
                  </div>
                  <h4 className="fw-bold mb-2">Appointments</h4>
                  <p className="text-muted mb-4">
                    Book a meeting with our pastoral team for counseling, prayer, and guidance.
                  </p>
                  <Button
                    as={Link}
                    to="/appointments"
                    variant="primary"
                    size="lg"
                    className="fw-bold mt-auto w-100"
                  >
                    Book Appointment
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
